import React, { useState, useEffect, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api';

function Index({ modal, toggleModal }) {
	const { t } = useTranslation()
	const reduxAccount = useSelector(state => state.account)

	const [mapState, setMapState] = useState({
		center: [],
		zoom: 13,
		controls: ["zoomControl"]
	});
	const [modalMap, setModalMap] = useState(false)
	const [selectedItem, setSelectedItem] = useState({
		'client_latitude': null,
		'client_longitude': null,
		'courier_latitude': null,
		'courier_longitude': null,
	})

	function toggleModalMap(bool = false) {
		setModalMap(bool)
		if (!bool) toggleModal(bool, 'mapOrder')
	}

	async function calculateCenter() {
		var selectedItemCopy = { ...selectedItem }
		// Преобразуем координаты в числа
		var coordinates = []
		if (modal.item.client_latitude) {
			coordinates.push({
				'latitude': modal.item.client_latitude,
				'longitude': modal.item.client_longitude
			})
			selectedItemCopy.client_latitude = modal.item.client_latitude
			selectedItemCopy.client_longitude = modal.item.client_longitude
		}

		if (modal.item.courier_id) {
			const response = await GET(`/delivery/courier-location/${modal.item.courier_id}`, {}, { loader: true })
			if (httpOk(response) && response?.data?.latitude) {
				coordinates.push({
					'latitude': response?.data?.latitude,
					'longitude': response?.data?.longitude
				})
				selectedItemCopy.courier_name = response?.data?.name
				selectedItemCopy.courier_latitude = response?.data?.latitude
				selectedItemCopy.courier_longitude = response?.data?.longitude
			}
		}

		coordinates = coordinates
			.map(item => {
				const lat = parseFloat(item.latitude);
				const lon = parseFloat(item.longitude);
				if (!isNaN(lat) && !isNaN(lon)) {
					return [lat, lon];
				}
				return null;
			})
			.filter(coord => coord !== null);

		if (coordinates.length === 0) return;

		const avgLat = coordinates.reduce((sum, coord) => sum + coord[0], 0) / coordinates.length;
		const avgLon = coordinates.reduce((sum, coord) => sum + coord[1], 0) / coordinates.length;

		setMapState(prev => ({
			...prev,
			center: [avgLat, avgLon]
		}));

		setModalMap(modal.mapOrder)
		setSelectedItem(selectedItemCopy)
	}

	useEffect(() => {
		if (modal.mapOrder) calculateCenter()
	}, [modal]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL UPDATE CLIENT */}
			<Modal show={modalMap} animation={false} centered size="xl"
				onHide={() => toggleModalMap()}>
				<Modal.Body>
					<div style={{ 'height': '700px', 'width': '100%' }}>
						<YMaps
							style={{ 'height': '700px', 'width': '100%' }}
							query={{
								load: "package.full",
								apikey: `${reduxAccount.map_token}`
							}}>
							<Map
								state={mapState}
								defaultOptions={{
									copyrightUaVisible: false,
									yandexMapDisablePoiInteractivity: true,
								}}
								style={{ 'height': '700px', 'width': '100%' }}>
								<Placemark
									geometry={[selectedItem.courier_latitude, selectedItem.courier_longitude]}
									options={{
										preset: 'islands#yellowStretchyIcon',
									}}
									properties={{
										iconContent: selectedItem.courier_name,
										intContent: t('courier'),
									}}
								/>
								<Placemark
									geometry={[selectedItem.client_latitude, selectedItem.client_longitude]}
									properties={{
										intContent: t('client'),
									}}
								/>
							</Map>
						</YMaps>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL UPDATE CLIENT */}
		</>
	)
}

export default Index